import { infoLog, eventLog, EVENT_DEBUG } from './general';

export const completeFormEvent = (details) => {
  if (EVENT_DEBUG && !window?.fbq) {
    infoLog('Complete Form Event: No FBQ found');
  }

  if (window?.fbq) {
    const contactData = {
      name: details?.name,
      email: details?.email,
      contactNumber: details?.contactNumber,  
    };
    window?.fbq('track', 'CompleteForm', contactData);
    if (EVENT_DEBUG) eventLog('CompleteForm', { contactData });
  }
};
